export default "__VITE_ASSET__BX$2TWVk__"